var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-picture"},_vm._l((_vm.dataList),function(item){return _c('div',{key:item.id,staticClass:"card"},[_c('div',{staticClass:"show-card show-card-front"},[_c('img',{attrs:{"src":item.icon}})]),_c('div',{staticClass:"show-card show-card-back"},[_c('img',{attrs:{"src":item.hoverIcon}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }